import { useMutation } from '@redwoodjs/web';

import { showErrorLong, showSuccessToast } from 'src/components/Toasts/toast';
import UPDATE_CANCELLATION_REASON from 'src/graphql/mutations/updateCancellationReason.mutation';
import { LogError } from 'src/lib';

const useUpdateCancellationReason = (onSuccess: () => void) => {
    const [updateCancellationReason, { loading }] = useMutation(UPDATE_CANCELLATION_REASON, {
        onCompleted: ({ updateCancellationReason: { message } }) => {
            showSuccessToast(message);
            onSuccess();
        },
        onError: (error) => {
            showErrorLong(error?.message);
            LogError(error);
        },
    });

    return {
        updatingCancellationReason: loading,
        onUpdateCancellationReason: async (updateCancellationReasonInput) => {
            return await updateCancellationReason({
                variables: {
                    input: updateCancellationReasonInput,
                },
            });
        },
    };
};
export default useUpdateCancellationReason;
